'use client';

import MobileBottomNavigation from '@/features/shop/components/mobile-bottom-navigation.component';
import { TOP_BANNER_FRAME_CLASS } from '@/features/shop/components/top-banner.component';
import type { ShopHomeData } from '@/features/shop/data/shop-home.mappers';
import { useShopHomeData } from '@/features/shop/data/use-shop-home';
import ShopFeature, { SHOP_HOME_HEADING } from '@/features/shop/shop.feature';
import { HeaderV2 } from '@/common/components/header-v2';

function ShopHomeLoadingShell() {
  return (
    <div className="bg-gray-30 [overflow-anchor:none]">
      <div className={TOP_BANNER_FRAME_CLASS} aria-hidden />
      <HeaderV2 />
      <main id="main-content" className="min-h-screen bg-gray-30">
        <h1 className="sr-only">{SHOP_HOME_HEADING}</h1>
        <div
          className="h-[200px] w-full animate-pulse bg-gray-40 md:aspect-[1440/493] md:h-auto"
          aria-hidden
        />
        <div className="mt-6 space-y-6 px-4 pb-6 md:mx-auto md:mt-10 md:max-w-[1200px] md:space-y-10 md:px-0 md:pb-10">
          <div className="flex h-14 gap-3 overflow-hidden md:h-[120px]" aria-hidden>
            {Array.from({ length: 6 }).map((_, index) => (
              <div
                key={index}
                className="size-14 shrink-0 animate-pulse rounded-full bg-gray-40 md:size-[72px]"
              />
            ))}
          </div>
          <div
            className="h-[280px] animate-pulse rounded-2xl bg-gray-40 md:h-[320px]"
            aria-hidden
          />
        </div>
      </main>
      <MobileBottomNavigation />
    </div>
  );
}

interface ShopHomeClientProps {
  initialData?: ShopHomeData;
}

export default function ShopHomeClient({
  initialData,
}: ShopHomeClientProps) {
  const { data } = useShopHomeData();
  const resolvedData = data ?? initialData;

  if (!resolvedData) {
    return <ShopHomeLoadingShell />;
  }

  return <ShopFeature data={resolvedData} />;
}
